import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { type BrandSummary } from '../../services/apiService';
import { type CampaignFilters } from './types';
import { BUSINESS_UNITS, CATEGORY_OPTIONS } from './constants';

interface CampaignFiltersProps {
    filters: CampaignFilters;
    onFiltersChange: (filters: CampaignFilters) => void;
    brands: BrandSummary[];
    conceptOptions: string[];
}

export function CampaignFiltersBar({ filters, onFiltersChange, brands, conceptOptions }: CampaignFiltersProps) {
    const handleFilterChange = (key: keyof CampaignFilters, value: string) => {
  onFiltersChange({ ...filters, [key]: value });
    };

    return (
        <div className="flex flex-wrap gap-2">
   <Select value={filters.businessUnit} onValueChange={(value) => handleFilterChange('businessUnit', value)}>
        <SelectTrigger className="w-[200px]">
                  <SelectValue />
            </SelectTrigger>
       <SelectContent>
           <SelectItem value="All">All Units</SelectItem>
    {BUSINESS_UNITS.map(unit => (
    <SelectItem key={unit} value={unit}>{unit}</SelectItem>
     ))}
              </SelectContent>
 </Select>

            <Select value={filters.category} onValueChange={(value) => handleFilterChange('category', value)}>
 <SelectTrigger className="w-[150px]">
          <SelectValue />
      </SelectTrigger>
    <SelectContent>
        {CATEGORY_OPTIONS.map(category => (
        <SelectItem key={category} value={category}>{category}</SelectItem>
   ))}
     </SelectContent>
       </Select>

       <Select value={filters.concept} onValueChange={(value) => handleFilterChange('concept', value)}>
       <SelectTrigger className="w-[200px]">
       <SelectValue />
      </SelectTrigger>
         <SelectContent>
 <SelectItem value="All Concepts">All Concepts</SelectItem>
  {conceptOptions.map((title) => (
              <SelectItem key={title} value={title}>
           {title}
     </SelectItem>
     ))}
   </SelectContent>
     </Select>

            <Select value={filters.brandId} onValueChange={(value) => handleFilterChange('brandId', value)}>
   <SelectTrigger className="w-[180px]">
  <SelectValue placeholder="All Brands" />
  </SelectTrigger>
   <SelectContent>
            <SelectItem value="all">All Brands</SelectItem>
       {brands.map(brand => (
      <SelectItem key={brand.id} value={brand.id.toString()}>{brand.name}</SelectItem>
           ))}
      </SelectContent>
            </Select>

  <Select value={filters.year} onValueChange={(value) => handleFilterChange('year', value)}>
       <SelectTrigger className="w-[100px]">
    <SelectValue />
    </SelectTrigger>
         <SelectContent>
       <SelectItem value="2024">2024</SelectItem>
    <SelectItem value="2025">2025</SelectItem>
    <SelectItem value="2026">2026</SelectItem>
           </SelectContent>
</Select>
        </div>
 );
}
